







































































































































































export default function (Component) {
  Component.options.__source = "src/components/d2-container-income-expenditure-edit-sg/index.vue"
}
